import { reactive } from 'vue';
import { acessoUtils } from '../util/acesso.utils.js';

export const pessoaLogada = reactive({
    current: null,

    getPermissoes(produto) {
        return {
            Criar: this.hasPermissao(produto, "Criar"),
            Editar: this.hasPermissao(produto, "Editar"),
            Excluir: this.hasPermissao(produto, "Excluir"),
            Visualizar: this.hasPermissao(produto, "Visualizar"),
        };
    },

    hasPermissao(produto, permissao) {
        if(!this.current) return false;
        
        if(this.current.isSuperAdm) return true;
        if(this.current.Administrador) return true;

        if(!produto) return false;
        if(!this.current.Permissoes) return false;
        if(!this.current.Permissoes[produto]) return false;

        if(!permissao) return this.current.Permissoes[produto];
       
        if(!this.current.Permissoes[produto][permissao]) return false;
        
        return this.current.Permissoes[produto][permissao];
    },

    async atualizar(pessoaLogada) {
        if (pessoaLogada && this.current != pessoaLogada) {
            this.pessoaLogada = pessoaLogada;
            return;
        }
        
        if (!pessoaLogada && !this.current) {
            this.current = await acessoUtils.loadPessoaLogada();
            return;
        }

        return this.current;
    },
})